/* WALDOS LEGEND — Refonte UX
   Barre de livraison offerte, échantillon automatique, ajouts en un geste,
   barre d'achat collée. Aucune dépendance : uniquement l'Ajax Cart API. */
(function () {
  'use strict';
  if (window.__wrLoaded) return;
  window.__wrLoaded = true;

  var WR = (window.WaldosRefonte = window.WaldosRefonte || {});
  WR.config = WR.config || {};

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function fetchCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(items) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function paintShipBars(cart) {
    var bars = document.querySelectorAll('[data-wr-ship]');
    Array.prototype.forEach.call(bars, function (bar) {
      var free = parseInt(bar.getAttribute('data-free'), 10) || 0;
      var gift = parseInt(bar.getAttribute('data-gift'), 10) || 0;
      var total = cart.total_price || 0;
      var msg = bar.querySelector('[data-wr-msg]');
      var fill = bar.querySelector('[data-wr-fill]');
      var tGift = bar.querySelector('[data-wr-tick="gift"]');
      var tFree = bar.querySelector('[data-wr-tick="free"]');

      if (fill) fill.style.width = Math.min(100, free ? (total / free) * 100 : 0) + '%';

      if (msg) {
        if (free && total >= free) {
          msg.innerHTML = '<b>Livraison offerte débloquée.</b>' + (gift ? ' Et l’échantillon aussi.' : '');
        } else if (gift && total >= gift) {
          msg.innerHTML = 'Échantillon offert débloqué · plus que <b>' + money(free - total) + '</b> pour la livraison offerte';
        } else if (gift) {
          msg.innerHTML = 'Plus que <b>' + money(gift - total) + '</b> pour l’échantillon offert';
        } else {
          msg.innerHTML = 'Plus que <b>' + money(Math.max(0, free - total)) + '</b> pour la livraison offerte';
        }
      }
      if (tGift) tGift.setAttribute('data-on', gift && total >= gift ? '1' : '0');
      if (tFree) tFree.setAttribute('data-on', free && total >= free ? '1' : '0');
    });

    var giftRow = document.querySelector('[data-wr-giftrow]');
    if (giftRow) {
      var at = parseInt(giftRow.getAttribute('data-gift'), 10) || 0;
      var on = at && cart.total_price >= at;
      giftRow.setAttribute('data-on', on ? '1' : '0');
      var state = giftRow.querySelector('[data-wr-giftstate]');
      if (state) state.textContent = on ? 'Offert' : 'À ' + money(at - cart.total_price);
    }
  }

  function syncSample(cart) {
    var id = WR.config.sampleVariantId;
    var at = WR.config.giftThreshold;
    if (!id || !at) return Promise.resolve(cart);

    var line = null;
    (cart.items || []).forEach(function (it) { if (it.variant_id === id) line = it; });
    var subtotal = (cart.items || []).reduce(function (s, it) {
      return it.variant_id === id ? s : s + it.final_line_price;
    }, 0);

    if (subtotal >= at && !line) return addToCart([{ id: id, quantity: 1 }]).then(fetchCart);
    if (subtotal < at && line) return changeLine(line.key, 0).then(fetchCart);
    return Promise.resolve(cart);
  }

  var busy = false;
  WR.refresh = function () {
    if (busy) return Promise.resolve();
    busy = true;
    return fetchCart()
      .then(syncSample)
      .then(function (cart) { paintShipBars(cart); WR.cart = cart; return cart; })
      .catch(function () {})
      .then(function (c) { busy = false; return c; });
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wr-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var vid = parseInt(btn.getAttribute('data-wr-add'), 10);
    if (!vid) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    addToCart([{ id: vid, quantity: 1 }])
      .then(function () { return WR.refresh(); })
      .then(function () {
        btn.setAttribute('data-state', 'added');
        btn.textContent = 'Ajouté ✓';
        if (btn.getAttribute('data-wr-reload') === '1') window.location.reload();
        else btn.disabled = false;
      })
      .catch(function () { btn.textContent = label; btn.disabled = false; });
  });

  function initSticky() {
    var bar = document.querySelector('[data-wr-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('form[action*="/cart/add"]');

    function toggle() {
      if (!anchor) { bar.setAttribute('data-show', '1'); return; }
      var r = anchor.getBoundingClientRect();
      bar.setAttribute('data-show', r.bottom < 60 ? '1' : '0');
    }
    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);

    var cta = bar.querySelector('[data-wr-stickyadd]');
    if (!cta) return;
    cta.addEventListener('click', function () {
      var vid = parseInt(bar.getAttribute('data-variant'), 10);
      if (!vid) return;
      var t = cta.textContent;
      cta.disabled = true;
      cta.textContent = 'Ajout…';
      addToCart([{ id: vid, quantity: 1 }])
        .then(function () { return WR.refresh(); })
        .then(function () { window.location.href = root() + 'cart'; })
        .catch(function () { cta.textContent = t; cta.disabled = false; });
    });
  }

  function start() {
    initSticky();
    if (document.querySelector('[data-wr-ship], [data-wr-giftrow]')) WR.refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
